import immutable from 'immutable';
import { updateBaseTableReducer } from '../../../../../util/reducer/update';
import {
  CLOSE_CLEANING_REPORT_ROUTE_IMAGE_MODAL,
  GET_CLEANING_REPORTS_FAIL,
  GET_CLEANING_REPORTS_REQUEST,
  GET_CLEANING_REPORTS_SUCCESS,
  GET_CLEANING_REPORT_ROUTE_IMAGE_FAIL,
  GET_CLEANING_REPORT_ROUTE_IMAGE_REQUEST,
  GET_CLEANING_REPORT_ROUTE_IMAGE_SUCCESS,
  RESET_CLEANING_REPORTS_STATE
} from './action';

const init = () => {
  const initValue = immutable.fromJS({
    list: undefined,
    routeImage: {
      // [cleaning-report-id]: { loading: boolean, imageUrl: ..., isSvgFile: boolean }
      data: undefined,
      modal: undefined
    }
  });

  return initValue
    .set('list', {
      data: [],
      isLoading: false,
      effect: 0,
      total: 0
    })
    .set('routeImage', {
      modal: {
        isOpen: false,
        selectedId: undefined,
        title: undefined
      },
      data: {}
    });
};

export default function cleaningReportsReducer(state = init(), action) {
  switch (action.type) {
    case GET_CLEANING_REPORTS_REQUEST:
      return state.update('list', (list) => ({
        ...list,
        isLoading: true
      }));

    case GET_CLEANING_REPORTS_SUCCESS: {
      const {
        payload: { data }
      } = action;
      const pagination = {
        total: data?.cleaningReports?.metadata?.totalCount
      };
      return state.update('list', (list) =>
        updateBaseTableReducer(list, data?.cleaningReports.data, pagination)
      );
    }

    case GET_CLEANING_REPORTS_FAIL:
      return state.update('list', (list) => ({
        ...list,
        isLoading: false
      }));

    case GET_CLEANING_REPORT_ROUTE_IMAGE_REQUEST: {
      const {
        payload: { id, title }
      } = action;

      return state.update('routeImage', (routeImage) => ({
        ...routeImage,
        data: {
          [id]: {
            loading: true,
            imageUrl: null
          }
        },
        modal: {
          isOpen: true,
          selectedId: id,
          title
        }
      }));
    }

    case GET_CLEANING_REPORT_ROUTE_IMAGE_SUCCESS: {
      const {
        payload: { id, imageUrl }
      } = action;

      return state.update('routeImage', (routeImage) => ({
        ...routeImage,
        data: {
          [id]: {
            loading: false,
            imageUrl
          }
        }
      }));
    }

    case GET_CLEANING_REPORT_ROUTE_IMAGE_FAIL: {
      const {
        payload: { id }
      } = action;

      return state.update('routeImage', (routeImage) => ({
        ...routeImage,
        data: {
          [id]: {
            ...(routeImage.data?.[id] || {}),
            loading: false
          }
        }
      }));
    }

    case CLOSE_CLEANING_REPORT_ROUTE_IMAGE_MODAL: {
      return state.update('routeImage', (routeImage) => ({
        ...routeImage,
        modal: {
          ...routeImage.modal,
          isOpen: false
        }
      }));
    }

    case RESET_CLEANING_REPORTS_STATE:
      return init();

    default:
      return state;
  }
}
